import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ACTION_FILTER_TYPE_MAPPING } from "../Constants/buyEngager";
export var removeParam = function removeParam(key, sourceURL) {
  try {
    var rtn = sourceURL.split('?')[0];
    var param;
    var params_arr = [];
    var queryString = sourceURL.indexOf('?') > 0 ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
      params_arr = queryString.split('&');
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) {
        rtn = "".concat(rtn, "?").concat(params_arr.join('&'));
      }
    }
    return rtn;
  } catch (error) {
    return sourceURL;
  }
};
export var getFilters = function getFilters(action, value, range, withOlxAutos) {
  var withFilter = {};
  withFilter = _defineProperty({}, ACTION_FILTER_TYPE_MAPPING[action], value || {
    min: range === null || range === void 0 ? void 0 : range.minValue,
    max: range === null || range === void 0 ? void 0 : range.maxValue
  });
  if (withOlxAutos) {
    withFilter = Object.assign(Object.assign({}, withFilter), {
      olxautos_listing: true
    });
  }
  return withFilter;
};